/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index space to autogenerate all the components and extensions
 * Used by "prepareSpaces"
 */

import Space from './space/Space'
export * from './space/Space'
export default Space
